<template>
  <span
    v-if="statusInfo"
    class="tag is-medium sc-invoice-audit-tag-status"
    :class="statusInfo.type">
    <sc-icon :icon="statusInfo.icon" />
    <span>{{ statusInfo.text }}</span>
  </span>
</template>

<script>
  import { ScIcon } from '@intelipost-js/secure-components';
  import EnumInvoiceAuditStatus from '../../enums/EnumInvoiceAuditStatus';

  export default {
    name: 'sc-invoice-audit-tag-status',
    props: {
      status: {
        type: String,
      },
      listStatus: {
        type: Object,
        default: () => EnumInvoiceAuditStatus,
      },
    },
    computed: {
      statusInfo() {
        return this.listStatus[this.status] || null;
      },
    },
    components: {
      ScIcon,
    },
  };
</script>

<style lang="scss" scoped>
  .sc-invoice-audit-tag-status {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/components/sc-invoice-audit-tag-status/ScInvoiceAuditTagStatus.vue